// extracted by mini-css-extract-plugin
export default {"table":"ProjectOverviewPage_table__HAl49","projectOverviewTable":"ProjectOverviewPage_projectOverviewTable__4tq88","projectOverview":"ProjectOverviewPage_projectOverview__zSuKI"};